import React, { FunctionComponent } from 'react';
import modelSelectorBaseStyles from './modelSelectorStyles';
import { useExpandSections } from '../../../../../../hooks/navigation/useExpandSections';
import GenericAccordion from '../../../../../../../gqlCommon/components/presentation/genericAccordion/GenericAccordion';
import CustomiseSectionTitle from '../../../simpleBrands/customiseSectionTitle/CustomiseSectionTitle';
import SectionStatesWrapper from '../../../../../../../common/components/configuratorStates/SectionStatesWrapper';

export interface IModelSelectorBase {
  error?: Error;
  sectionName: string;
}

const ModelSelectorBase: FunctionComponent<IModelSelectorBase> = ({ children, error, sectionName }) => {
  const { setExpandedSection, currentSection } = useExpandSections(sectionName);
  const styles = modelSelectorBaseStyles();

  return (
    <GenericAccordion
      expanded={currentSection}
      setExpanded={setExpandedSection}
      classes={{ accordionDetails: styles.container, accordionSummary: styles.accordionSummary }}
      dataTest={`container:section:model${sectionName}`}
      summary={
        <CustomiseSectionTitle
          label={sectionName}
          translationId={'trans__configurator__customise_page_banner__variant'}
          testId={sectionName}
        />
      }
      details={<SectionStatesWrapper error={error}>{children}</SectionStatesWrapper>}
    />
  );
};

export default ModelSelectorBase;
